define([
    'handlebars',
    'modules/common/controls/select2base',
    'appcontext'
], (Handlebars, Select2Base, appContext) => Select2Base.extend({
    template: Handlebars.compile(
        '<a href="#" class="deselect-all"><i class="icon-remove"></i> {{_ "Deselect all"}}</a>'
    ),

    defaults: _.extend({
        allowDeselectAll: false
    }, Select2Base.prototype.defaults),

    initialize () {
        Select2Base.prototype.initialize.apply(this, arguments);

        const choices = this.choices = this.options.choices;
        if (this.choices) {
            this.listenTo(this.choices, 'reset', this.render);
        }

        _.extend(this.options, {
            tags () {
                return (choices || []).map((tag) => tag.get('name'));
            },
            tokenSeparators: [',', ';'],
            choices: null,
            formatNoMatches: this.choices ? _.bind(this.formatNoMatches, this) : null
        });
    },

    formatNoMatches () {
        return appContext.tr('No matches found');
    },

    render () {
        Select2Base.prototype.render.apply(this, arguments);

        // this.$el is expected to be already attached to DOM at this moment
        this.$el.select2('destroy').select2(_.clone(this.options));

        if (this.options.allowDeselectAll) {
            this.setupDeselectAll();
        }

        return this;
    },

    remove () {
        this.$el.select2('destroy');
        Select2Base.prototype.remove.apply(this, arguments);
    },

    // TODO: reset search text!
    setupDeselectAll () {
        const self = this;

        function deselectAll () {
            self.data([]);
            self.close();
            self.$el.trigger('change');
            return false;
        }

        function addSelectAllLi () {
            const select2drop = self.dropdown();
            if (select2drop.find('.select2-select-all').length) {
                return;
            }
            const ul = select2drop.find('ul.select2-results');
            const li = $('<li>').addClass('select2-select-all');
            const div = $('<div>').addClass('select2-result-label');
            const template = $(self.template());

            template.appendTo(div);
            div.appendTo(li);
            li.prependTo(ul);

            div.find('.deselect-all').on('click', deselectAll);
        }

        const container = self.$el.select2('container');
        const searchInput = $(container.find('input:first'));

        // we need to render on each input event because select2 doesn't trigger any event when no matches found
        searchInput.on('input', addSelectAllLi);

        this.on('select2-open', addSelectAllLi);
        this.on('select2-loaded', addSelectAllLi);
    }

}));
